module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title2",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("All That Glitters")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Cake decorating is about making something sweet and precious. We make cakes to celebrate cherished friends and family and to express our love for them. Metallics are a wonderful way to symbolically show someone that they are treasured. Nothing can beat the prestige of pure edible gold. It will hold the spotlight and turn the glamour up to ‘eleven’.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Gold and other metallics can be used on cakes in endless ways. There are many edibles with a brilliant shine and the applications and possibilities for design are limitless. I have tried in this book to include as many different materials and techniques as I can. I am lucky to have a busy cake studio where we work with new designs and techniques on a regular basis. The designs in this book draw on our work in the studio: the cakes we have loved the most and new ideas that have arisen from the working process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The danger of metallics is to overdo it and end up with something more trashy than refined. There’s nothing wrong with gold-on-gold-on-gold, as long as it’s done right. The trick is artful application and an eye for design. Sometimes the best use of metallic is to highlight some fine details with a light touch. Sometimes, a liberal use of pearl, gold and glitter will be exactly the luxurious look that’s desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here are few things to think about when designing with metallics:")]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("CONTRAST")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For example, if I’m using a lot of metallic leaf and highlighting, it may be best to leave the base icing with a matte finish rather than a pearlised one. The shine of metallics will be highlighted when set against a flatter background.")]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("TEXTURE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The texture of metallics can either be flat and shiny like leafing and lustre, or heavy and detailed such as gold painted mouldings. Use texture sparingly and intentionally. I prefer to place sugar flowers against less heavily textured parts of the cake, to avoid a ‘messy’ feel, and to keep some areas of the cake unadorned to highlight the sharp and beautiful shape.")]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("COMPOSITION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Think about how the eye moves around the cake. Is there a strong focal point or a few smaller elements that lead the eye from one to the next? Careful use of metallic features will help in creating a unified design that’s pleasing to look over.")]), _vm._v(" "), _c('h5', {
    staticClass: "subhead5"
  }, [_vm._v("BALANCE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Is the design symmetrical or asymmetric? Symmetrical designs often look more formal and structured; they are perfect for regal and classic styles and work beautifully with metallics. The details should look precise and deliberate. Asymmetric styles are often more relaxed and informal but should still be balanced. For example, the heavy metallic flowers on the Fall Foliage cake are balanced by the delicate ‘sunset’ airbrushing of copper and gold on the lower tiers and framed by the unadorned upper tiers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I hope you will enjoy this book and find inspiration for your own cake designs. Thank you for joining me on this fun journey into the world of decorating with metallics!")]), _vm._v(" "), _c('p', {
    staticClass: "image-left"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P4-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f41d7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 63
// module chunks = 0